import React from 'react';
import PropTypes from 'prop-types';
import {
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core';

class DynamicFields extends React.Component {

  static propTypes = {

    data: PropTypes.data,

  };

  static defaultProps = {

    data: [],

  };

  constructor(props) {

    super(props);

    this.state = {
      radioGroupValue: '',

    };

  }

  handleRadioGroupChange = event => {
    this.setState({radioGroupValue: event.target.value})
    this.props.onChange(this)
  }

  renderDynamic() {

    const fields = [];
    const { data, onChange, onClose } = this.props;
    const { radioGroupValue } = this.state;

    if (data.form !== '') {

      const types = JSON.parse(data.form);

      types.forEach((field) => {

        switch (field.componentId) {
          case 1:
            fields.push(<TextField name={field.name} type="date" required label={field.name} onChange={onChange(this)} />);
            break;
          case 2:
            fields.push(<TextField name={field.name} required label={field.name} onChange={onChange(this)} />);
            break;
          case 3:
            fields.push(<TextField name={field.name} type="number" required label={field.name} onChange={onChange(this)} />);
            break;
          case 4:
          fields.push(
            <RadioGroup
              aria-label={field.name}
              name={field.name}
              value={this.state.radioGroupValue}
              onChange={this.handleRadioGroupChange}
            >
              <FormControlLabel value="true" control={<Radio color="primary"/>} label="Sim" />
              <FormControlLabel value="false" control={<Radio color="primary" />} label="Não" />
            </RadioGroup>
          );
            break;
          default:
            return null;
        }

      });

    }
    onClose(fields);

    return fields;

  }

  render() {

    return (
      <div>
        {this.renderDynamic()}
      </div>
    );

  }

}

export default DynamicFields;



// WEBPACK FOOTER //
// ./src/components/tracker/Check/DynamicFields.js